const bases= {
    sso: {
        api: process.env.VUE_APP_SSO_API_BASE_URL,
            ui: process.env.VUE_APP_SSO_WEB_BASE_URL,
    },
    members: {
        api: process.env.VUE_APP_MEMBERS_API_BASE_URL,
            ui: process.env.VUE_APP_MEMBERS_WEB_BASE_URL,
    },
    training: {
        api: process.env.VUE_APP_TRAINING_API_BASE_URL,
            ui: process.env.VUE_APP_TRAINING_WEB_BASE_URL,
    },
    flex: {
        ui: process.env.VUE_APP_ETRAINING_WEB_BASE_URL,
    },
    excursions: {
        ui: process.env.VUE_APP_EXCURSIONS_WEB_BASE_URL
    },
    achievement: {
        ui: process.env.VUE_APP_ACHIEVEMENT_WEB_BASE_URL
    }
};
export var routes = {
    home: bases.sso.ui + "/",
    nothing: bases.sso.ui + "/nothing",
    users: {
        management: bases.sso.ui + "/user/management"
    },
    members: {
        member: {
            management: bases.members.ui + "/member/management",
            add: bases.members.ui + "/member/add",
            edit: `${bases.members.ui}/member/edit`,
        },
        unit: {
            management: bases.members.ui + "/unit/management",
            add: bases.members.ui + "/unit/add",
        },
        census: {
            management: bases.members.ui + "/census/history",
            add: bases.members.ui + "/census/add",
            submit: bases.members.ui + "/census/submit",
        },
        licenses: {
            active: `${bases.members.ui}/licenses/active`,
            pending: `${bases.members.ui}/licenses/pending`
        },
        support: {
            active: `${bases.members.ui}/support/active`
        },
        report: {
            census: `${bases.members.ui}/reports/census`,
            profiles: `${bases.members.ui}/reports/trainingProfiles`,
            default: `${bases.members.ui}/reports/default`
        },
        conference: {
            management: `${bases.members.ui}/conference`,
        },
        jamboree: {
            management: bases.members.ui + "/jamboree",
            add: bases.members.ui + "/jamboree/payment",
            submit: bases.members.ui + "/jamboree/payment/list",
        }
    },
    training: {
        trainings: `${bases.training.ui}/trainings`,
        evaluation: `${bases.training.ui}/evaluations`,
        participations: `${bases.training.ui}/participations`,
        progress: `${bases.training.ui}/member`,
        trainerApplyActivitiesList: `${bases.training.ui}/apply-activities/trainer`,
        applyActivitiesList: `${bases.training.ui}/apply-activities/trainee`,
        apply: `${bases.training.ui}/trainings/apply`
    },
    flex: {
        applyActivitiesMgmt: `${bases.flex.ui}/secure/list-apply-activities`,
    },
    excursions: {
        excursionActivities: `${bases.excursions.ui}/excursions`
    },
    achievement: {
        progress: `${bases.achievement.ui}/progress`
    }

};

export var roles = {
        home: null,
        nothing: null,
        users: {
            management: ["ADMIN"]
        },
        members: {
            member: {
                management: ['TRAINING_ADMIN', 'FINANCE_ADMIN', 'UNIT_ADMIN', 'UNIT_MOD', 'UNIT_VIEWER', 'TROOP_ADMIN'],
                add: ['TRAINING_ADMIN', 'FINANCE_ADMIN', 'UNIT_ADMIN', 'UNIT_MOD'],
                edit: ['TRAINING_ADMIN', 'FINANCE_ADMIN', 'UNIT_ADMIN', 'UNIT_MOD', 'UNIT_VIEWER', 'TROOP_ADMIN'],
            },
            unit: {
                management: ['FINANCE_ADMIN', 'UNIT_ADMIN', 'UNIT_MOD', 'UNIT_VIEWER'],
                add: ["ADMIN"]
            },
            census: {
                management: ['FINANCE_ADMIN', 'UNIT_ADMIN', 'UNIT_MOD', 'UNIT_VIEWER'],
                add: ['FINANCE_ADMIN', 'UNIT_ADMIN', 'UNIT_MOD', 'UNIT_VIEWER'],
                submit: ['FINANCE_ADMIN', 'UNIT_ADMIN', 'UNIT_MOD', 'UNIT_VIEWER'],
            },
            licenses: {
                active: ['TRAINING_ADMIN', 'TRAIN_MOD', 'FINANCE_ADMIN', 'UNIT_ADMIN', 'UNIT_MOD', 'UNIT_VIEWER'],
                add: ['UNIT_ADMIN', 'UNIT_MOD', 'UNIT_VIEWER'],
                pending: ['UNIT_ADMIN', 'UNIT_MOD', 'UNIT_VIEWER'],
            },
            support: {
                active: ['FINANCE_ADMIN', 'UNIT_ADMIN', 'UNIT_MOD', 'UNIT_VIEWER'],
                add: ['UNIT_ADMIN', 'UNIT_MOD', 'UNIT_VIEWER'],
                pending: ['UNIT_ADMIN', 'UNIT_MOD', 'UNIT_VIEWER'],
            },
            report: {
                census: ['FINANCE_ADMIN', 'UNIT_ADMIN', 'UNIT_MOD', 'UNIT_VIEWER', 'TROOP_ADMIN'],
                profiles: ['TRAINING_ADMIN', 'TRAIN_MOD', 'FINANCE_ADMIN', 'UNIT_ADMIN', 'UNIT_MOD', 'UNIT_VIEWER'],
            },
            conference: {
                management: ["ADMIN"]
            },
            jamboree: {
                management: ["ADMIN"],
                edit: ['FINANCE_ADMIN', 'UNIT_ADMIN', 'UNIT_MOD', 'UNIT_VIEWER'],
            }
        },
        training: {
            trainings: ['TRAINING_ADMIN', 'TRAIN_MOD', 'TRAINER'],
            leaders: ['TRAINING_ADMIN'],
            parametrics: ['TRAINING_ADMIN'],
            participation: ['TRAINING_ADMIN', 'TRAIN_MOD', 'FINANCE_ADMIN', 'UNIT_ADMIN', 'UNIT_MOD', 'UNIT_VIEWER'],
        },
        flex: {
            plansList: [],
            applyActivitiesList: [],
            trainerApplyActivitiesList: [],
            applyActivitiesMgmt: []
        },
        excursions: {
            excursionActivities: ['UNIT_ADMIN', 'UNIT_MOD', 'UNIT_VIEWER', 'TROOP_ADMIN', 'COMMISSION_PRESIDENT',
                'EXCURSION_VIEWER', 'AFFAIRS_COMMISSIONER', 'NAVY_COMMISSIONER', 'CAPTAIN', 'BRANCH_COMMISSIONER'],
        }
};


